var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.DataAdjustment"),
        width: _vm.$selectByLang("500px", "500px", "750px"),
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          attrs: {
            "label-width": _vm.$selectByLang("70px", "70px", "110px"),
            "label-position": "left"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("Tool.PartnerCategory") + ":" } },
            [
              _c("el-cascader", {
                staticStyle: { width: "100%" },
                attrs: { options: _vm.dataCategoris },
                on: {
                  change: function(p) {
                    return _vm.onDataCategoryChange(p)
                  }
                },
                model: {
                  value: _vm.dataCategory,
                  callback: function($$v) {
                    _vm.dataCategory = $$v
                  },
                  expression: "dataCategory"
                }
              })
            ],
            1
          ),
          _vm.dataCategoryValue === "EQ_SIZE_TYPE"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.OriginalData") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "div",
                        {
                          style: _vm.$selectByLang(
                            "width: 65px",
                            "width: 65px",
                            "width: 250px"
                          )
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerSize")))]
                      ),
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.originEqSize,
                            callback: function($$v) {
                              _vm.originEqSize = $$v
                            },
                            expression: "originEqSize"
                          }
                        },
                        _vm._l(_vm.eqSzies, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.code }
                          })
                        }),
                        1
                      ),
                      _c(
                        "div",
                        {
                          style:
                            "margin-left: 5px;" +
                            _vm.$selectByLang(
                              "width: 65px",
                              "width: 65px",
                              "width: 250px"
                            )
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerType")))]
                      ),
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.originEqType,
                            callback: function($$v) {
                              _vm.originEqType = $$v
                            },
                            expression: "originEqType"
                          }
                        },
                        _vm._l(_vm.eqTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "EQ_SIZE_TYPE"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c(
                        "div",
                        {
                          style: _vm.$selectByLang(
                            "width: 65px",
                            "width: 65px",
                            "width: 250px"
                          )
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerSize")))]
                      ),
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.newEqSize,
                            callback: function($$v) {
                              _vm.newEqSize = $$v
                            },
                            expression: "newEqSize"
                          }
                        },
                        _vm._l(_vm.eqSzies, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.code }
                          })
                        }),
                        1
                      ),
                      _c(
                        "div",
                        {
                          style:
                            "margin-left: 5px;" +
                            _vm.$selectByLang(
                              "width: 65px",
                              "width: 65px",
                              "width: 250px"
                            )
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.ContainerType")))]
                      ),
                      _c(
                        "el-select",
                        {
                          model: {
                            value: _vm.newEqType,
                            callback: function($$v) {
                              _vm.newEqType = $$v
                            },
                            expression: "newEqType"
                          }
                        },
                        _vm._l(_vm.eqTypes, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { value: item.code }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "CONTAINER_AND_SEAL_NO_TYPE"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.clearByBusiness,
                          placeholder: _vm.clearByBusiness
                            ? ""
                            : _vm.$t("SeaExport.inputContainerNo")
                        },
                        model: {
                          value: _vm.containerNo,
                          callback: function($$v) {
                            _vm.containerNo = $$v
                          },
                          expression: "containerNo"
                        }
                      }),
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.clearByBusiness,
                          placeholder: _vm.clearByBusiness
                            ? ""
                            : _vm.$t("SeaExport.inputSealNo")
                        },
                        model: {
                          value: _vm.sealNo,
                          callback: function($$v) {
                            _vm.sealNo = $$v
                          },
                          expression: "sealNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("CargoMsg.Cargo_ClearData") + ":") +
                          " "
                      ),
                      _c("el-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.onClearByBusinessChange()
                          }
                        },
                        model: {
                          value: _vm.clearByBusiness,
                          callback: function($$v) {
                            _vm.clearByBusiness = $$v
                          },
                          expression: "clearByBusiness"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "CATEGORY_OF_GOODS_TYPE"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "cargoCode",
                          disabled: _vm.clearByBusiness,
                          "select-type":
                            _vm.selectTypeNames.basic_data_CargoInformation,
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.cargoCode,
                          placeholder: _vm.$t("SeaExport.PleaseSelectCategory"),
                          "allow-create": false
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.cargoCodeChange(p.value)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("CargoMsg.Cargo_ClearData") + ":") +
                          " "
                      ),
                      _c("el-checkbox", {
                        attrs: {
                          disabled:
                            _vm.dataCategoryValue === "BUSINESS_OP_TYPE" ||
                            _vm.dataCategoryValue === "BUSINESS_SALES_TYPE"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onClearByBusinessChange()
                          }
                        },
                        model: {
                          value: _vm.clearByBusiness,
                          callback: function($$v) {
                            _vm.clearByBusiness = $$v
                          },
                          expression: "clearByBusiness"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "IC_CARRIER_COMPANY"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "icCarrierCompany",
                          disabled: _vm.clearByBusiness,
                          "method-params": {
                            truckCmp: true,
                            active: true,
                            companyLob: "integratedJob"
                          },
                          "default-value": _vm.icCarrierCompanyValue || "",
                          placeholder:
                            _vm.$t("SeaExport.PleaseSelect") +
                            _vm.$t("SeaExport.Carrier")
                        },
                        on: {
                          change: function(p) {
                            _vm.icCarrierCompanyValue = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("CargoMsg.Cargo_ClearData") + ":") +
                          " "
                      ),
                      _c("el-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.onClearByBusinessChange()
                          }
                        },
                        model: {
                          value: _vm.clearByBusiness,
                          callback: function($$v) {
                            _vm.clearByBusiness = $$v
                          },
                          expression: "clearByBusiness"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "IC_BOOKING_AGENT"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "icBookingAgent",
                          disabled: _vm.clearByBusiness,
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            bookingAgent: true,
                            companyLob: "integratedJob",
                            active: true
                          },
                          filterable: "",
                          clearable: true,
                          "default-value": _vm.icBookingAgentValue || "",
                          placeholder:
                            _vm.$t("SeaExport.PleaseSelect") +
                            _vm.$t("SeaExport.BookingAgent")
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.icBookingAgentValue = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("CargoMsg.Cargo_ClearData") + ":") +
                          " "
                      ),
                      _c("el-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.onClearByBusinessChange()
                          }
                        },
                        model: {
                          value: _vm.clearByBusiness,
                          callback: function($$v) {
                            _vm.clearByBusiness = $$v
                          },
                          expression: "clearByBusiness"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "IC_WAREHOUSE_SUPPLIER"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "icWarehouseSupplier",
                          disabled: _vm.clearByBusiness,
                          "method-params": {
                            warehouse: true,
                            active: true,
                            companyLob: "integratedJob"
                          },
                          "default-value": _vm.icWarehouseSupplierValue || "",
                          placeholder:
                            _vm.$t("SeaExport.PleaseSelect") +
                            _vm.$t("SeaExport.WarehouseSupplier")
                        },
                        on: {
                          change: function(p) {
                            _vm.icWarehouseSupplierValue = p.value
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("CargoMsg.Cargo_ClearData") + ":") +
                          " "
                      ),
                      _c("el-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.onClearByBusinessChange()
                          }
                        },
                        model: {
                          value: _vm.clearByBusiness,
                          callback: function($$v) {
                            _vm.clearByBusiness = $$v
                          },
                          expression: "clearByBusiness"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          !(_vm.isXycw && _vm.lob === "SE") &&
          _vm.dataCategoryValue === "ETA_DATE_TYPE"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _vm.lob === "SE"
                        ? _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "unBerthPlanDate",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_PleaseFill") +
                                _vm.$t("SeaExport.PlanDepartureTime")
                            },
                            model: {
                              value: _vm.unBerthPlanDate,
                              callback: function($$v) {
                                _vm.unBerthPlanDate = $$v
                              },
                              expression: "unBerthPlanDate"
                            }
                          })
                        : _vm._e(),
                      _vm.lob === "AE"
                        ? _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "estimatedDepartureTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_PleaseFill") +
                                _vm.$t("CargoMsg.Cargo_EstimatedDepartureTime")
                            },
                            model: {
                              value: _vm.estimatedDepartureTime,
                              callback: function($$v) {
                                _vm.estimatedDepartureTime = $$v
                              },
                              expression: "estimatedDepartureTime"
                            }
                          })
                        : _vm._e(),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "estimatedArrivalTime",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm",
                          placeholder:
                            _vm.$t("CargoMsg.Cargo_PleaseFill") +
                            (_vm.lob === "SE"
                              ? _vm.$t("SeaExport.EstimatedArrivalTime")
                              : _vm.$t("CargoMsg.Cargo_EstimatedArrivalTime"))
                        },
                        model: {
                          value: _vm.estimatedArrivalTime,
                          callback: function($$v) {
                            _vm.estimatedArrivalTime = $$v
                          },
                          expression: "estimatedArrivalTime"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.isXycw &&
          _vm.lob === "SE" &&
          _vm.dataCategoryValue === "CUR_ETA_DATE_TYPE"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "currentETD",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm",
                          placeholder:
                            _vm.$t("CargoMsg.Cargo_PleaseFill") +
                            _vm.$t("SeaExport.NowPlanDepartureTime")
                        },
                        model: {
                          value: _vm.currentETD,
                          callback: function($$v) {
                            _vm.currentETD = $$v
                          },
                          expression: "currentETD"
                        }
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "currentArrivalETA",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm",
                          placeholder:
                            _vm.$t("CargoMsg.Cargo_PleaseFill") +
                            _vm.$t("SeaExport.CurrentETA")
                        },
                        model: {
                          value: _vm.currentArrivalETA,
                          callback: function($$v) {
                            _vm.currentArrivalETA = $$v
                          },
                          expression: "currentArrivalETA"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "ATD_ATA_DATE_TYPE"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _vm.lob === "SE"
                        ? _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "actualUnBerthPlanDate",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_PleaseFill") +
                                _vm.$t("SeaExport.RealDepartureTime")
                            },
                            model: {
                              value: _vm.actualUnBerthPlanDate,
                              callback: function($$v) {
                                _vm.actualUnBerthPlanDate = $$v
                              },
                              expression: "actualUnBerthPlanDate"
                            }
                          })
                        : _vm._e(),
                      _vm.lob === "AE"
                        ? _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "actualDepartureTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_PleaseFill") +
                                _vm.$t("CargoMsg.Cargo_ActualDepartureTime")
                            },
                            model: {
                              value: _vm.actualDepartureTime,
                              callback: function($$v) {
                                _vm.actualDepartureTime = $$v
                              },
                              expression: "actualDepartureTime"
                            }
                          })
                        : _vm._e(),
                      _vm.lob === "SE"
                        ? _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "actualArrivalTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_PleaseFill") +
                                _vm.$t("SeaExport.ArrivalTime")
                            },
                            model: {
                              value: _vm.actualArrivalTime,
                              callback: function($$v) {
                                _vm.actualArrivalTime = $$v
                              },
                              expression: "actualArrivalTime"
                            }
                          })
                        : _vm._e(),
                      _vm.lob === "AE"
                        ? _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "actualArrivalTime",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm",
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_PleaseFill") +
                                _vm.$t("CargoMsg.Cargo_ActualArrivalTime")
                            },
                            model: {
                              value: _vm.actualArrivalTime,
                              callback: function($$v) {
                                _vm.actualArrivalTime = $$v
                              },
                              expression: "actualArrivalTime"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.isXycw &&
          _vm.lob === "SE" &&
          _vm.dataCategoryValue === "ORIGINAL_ETA_DATE_TYPE"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "unBerthPlanDate",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm",
                          placeholder:
                            _vm.$t("CargoMsg.Cargo_PleaseFill") +
                            _vm.$t("SeaExport.OriginalPlanDepartureTime")
                        },
                        model: {
                          value: _vm.unBerthPlanDate,
                          callback: function($$v) {
                            _vm.unBerthPlanDate = $$v
                          },
                          expression: "unBerthPlanDate"
                        }
                      }),
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          no: "estimatedArrivalTime",
                          type: "datetime",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          format: "yyyy-MM-dd HH:mm",
                          placeholder:
                            _vm.$t("CargoMsg.Cargo_PleaseFill") +
                            _vm.$t("SeaExport.OriginalETA")
                        },
                        model: {
                          value: _vm.estimatedArrivalTime,
                          callback: function($$v) {
                            _vm.estimatedArrivalTime = $$v
                          },
                          expression: "estimatedArrivalTime"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.isBusinessPeople
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _vm.dataCategoryValue === "BUSINESS_OP_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            ref: "op",
                            attrs: {
                              no: "op",
                              disabled: _vm.clearByBusiness,
                              "method-params": {
                                officeId: _vm.job.opOffice,
                                category: "role",
                                shape: "op"
                              },
                              "default-value": _vm.userId || "",
                              placeholder: _vm.$t(
                                "SeaExport.PleaseSelectAction"
                              ),
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(p, "op")
                              }
                            }
                          }),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "opDepartment",
                              disabled: _vm.clearByBusiness,
                              "office-id": Number(_vm.job.opOffice),
                              enables: true,
                              placeholder: _vm.$t(
                                "SeaExport.PleaseSelectOpDep"
                              ),
                              "department-id": Number(_vm.depId)
                            },
                            on: {
                              change: function(p) {
                                _vm.depId = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_SALES_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            ref: "sales",
                            attrs: {
                              no: "sales",
                              disabled: _vm.clearByBusiness,
                              "method-params": {
                                officeId: _vm.job.opOffice,
                                category: "role",
                                shape: "sales"
                              },
                              "default-value": _vm.userId || "",
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SelectSalesPerson"
                              ),
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(p, "sales")
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "opDepartment",
                              disabled: _vm.clearByBusiness,
                              "office-id": Number(_vm.job.opOffice),
                              enables: true,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SelectSalesPersonDep"
                              ),
                              "department-id": Number(_vm.depId)
                            },
                            on: {
                              change: function(p) {
                                _vm.depId = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_CSR_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            ref: "csr",
                            attrs: {
                              no: "csr",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t("CargoMsg.Cargo_SelectCsr"),
                              "method-params": {
                                officeId: _vm.job.opOffice,
                                category: "role",
                                shape: "csr"
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(p, "csr")
                              }
                            }
                          }),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "opDepartment",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SelectCsrDep"
                              ),
                              "office-id": Number(_vm.job.opOffice),
                              enables: true,
                              "department-id": Number(_vm.depId)
                            },
                            on: {
                              change: function(p) {
                                _vm.depId = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_DC_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            ref: "dc",
                            attrs: {
                              no: "dc",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t("CargoMsg.Cargo_SelectDoc"),
                              "method-params": {
                                officeId: _vm.job.opOffice,
                                category: "role",
                                shape: "doc"
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(p, "doc")
                              }
                            }
                          }),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "opDepartment",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SelectDocDep"
                              ),
                              "office-id": Number(_vm.job.opOffice),
                              enables: true,
                              "department-id": Number(_vm.depId)
                            },
                            on: {
                              change: function(p) {
                                _vm.depId = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_OVERSEA_OP_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            ref: "overseaOp",
                            attrs: {
                              no: "overseaOp",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SelectOverseaOp"
                              ),
                              "default-value": _vm.userId || "",
                              "static-options": _vm.overseaAgentUsersList,
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(p, "overseaOp")
                              }
                            }
                          }),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "opDepartment",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SelectOverseaOpDep"
                              ),
                              "office-id": Number(_vm.job.opOffice),
                              enables: true,
                              "department-id": Number(_vm.depId)
                            },
                            on: {
                              change: function(p) {
                                _vm.depId = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_CARGO_SALES_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "cargoSalesId",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SelectCargoSales"
                              ),
                              "method-params": {
                                category: "role",
                                shape: "salesOfGoods"
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_UDR1_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "userDefinedRoleId1",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t("SeaExport.UserDefinedRole1"),
                              "method-params": {
                                category: "role",
                                shape: "userDefinedRole1"
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(
                                  p,
                                  "userDefinedRole1"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_UDR2_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "userDefinedRoleId2",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t("SeaExport.UserDefinedRole2"),
                              "method-params": {
                                category: "role",
                                shape: "userDefinedRole2"
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(
                                  p,
                                  "userDefinedRole2"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_UDR3_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "userDefinedRoleId3",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_userDefinedRole3"
                              ),
                              "method-params": {
                                category: "role",
                                shape: "userDefinedRole3"
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(
                                  p,
                                  "userDefinedRole3"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_UDR4_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "userDefinedRoleId4",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_userDefinedRole4"
                              ),
                              "method-params": {
                                category: "role",
                                shape: "userDefinedRole4"
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(
                                  p,
                                  "userDefinedRole4"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_UDR5_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "userDefinedRoleId5",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_userDefinedRole5"
                              ),
                              "method-params": {
                                category: "role",
                                shape: "userDefinedRole5"
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(
                                  p,
                                  "userDefinedRole5"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_UDR6_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "userDefinedRoleId6",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_userDefinedRole6"
                              ),
                              "method-params": {
                                category: "role",
                                shape: "userDefinedRole6"
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(
                                  p,
                                  "userDefinedRole6"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_UDR7_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "userDefinedRoleId7",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_userDefinedRole7"
                              ),
                              "method-params": {
                                category: "role",
                                shape: "userDefinedRole7"
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(
                                  p,
                                  "userDefinedRole7"
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_PRE_PORT_PLANNER_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "prePortPlanner",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_PrePortBusinessLeader"
                              ),
                              "method-params": {
                                category: "role",
                                shape: "sealine",
                                officeId: _vm.job.opOffice
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(p, "seaLine")
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_LAST_MILE_PLANNER_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "lastMilePlanner",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_LastMileBusinessLeader"
                              ),
                              "method-params": {
                                category: "role",
                                shape: "sealine",
                                officeId: _vm.job.opOffice
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(p, "seaLine")
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.dataCategoryValue === "BUSINESS_PLANNER_TYPE"
                    ? _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c("cargo-user-select", {
                            attrs: {
                              no: "planner",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SelectPlanner"
                              ),
                              "method-params": {
                                officeId: _vm.job.opOffice,
                                category: "role",
                                shape: "seaLine"
                              },
                              "default-value": _vm.userId || "",
                              "merge-load": true
                            },
                            on: {
                              change: function(p) {
                                _vm.userId = p.value
                                _vm.businessPeopleChangeHandler(p, "seaLine")
                              }
                            }
                          }),
                          _c("cargo-department-select", {
                            attrs: {
                              no: "opDepartment",
                              disabled: _vm.clearByBusiness,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_SelectPlannerDep"
                              ),
                              "office-id": Number(_vm.job.opOffice),
                              enables: true,
                              "department-id": Number(_vm.depId)
                            },
                            on: {
                              change: function(p) {
                                _vm.depId = p.value
                              }
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("CargoMsg.Cargo_ClearData") + ":") +
                          " "
                      ),
                      _c("el-checkbox", {
                        attrs: {
                          disabled:
                            _vm.dataCategoryValue === "BUSINESS_OP_TYPE" ||
                            _vm.dataCategoryValue === "BUSINESS_SALES_TYPE"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onClearByBusinessChange()
                          }
                        },
                        model: {
                          value: _vm.clearByBusiness,
                          callback: function($$v) {
                            _vm.clearByBusiness = $$v
                          },
                          expression: "clearByBusiness"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.isLocalService
            ? _c(
                "el-form-item",
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("SeaExport.CheckStatuses")))
                  ]),
                  _c("el-checkbox", {
                    attrs: { disabled: _vm.localService.clearCheck },
                    model: {
                      value: _vm.localService.checkState,
                      callback: function($$v) {
                        _vm.$set(_vm.localService, "checkState", $$v)
                      },
                      expression: "localService.checkState"
                    }
                  }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("SeaExport.ClearStatuses")))
                  ]),
                  _c("el-checkbox", {
                    on: {
                      change: function(val) {
                        if (val) {
                          _vm.localService.checkState = false
                        }
                      }
                    },
                    model: {
                      value: _vm.localService.clearCheck,
                      callback: function($$v) {
                        _vm.$set(_vm.localService, "clearCheck", $$v)
                      },
                      expression: "localService.clearCheck"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.isDestinationPortService
            ? _c(
                "el-form-item",
                [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("SeaExport.CheckStatuses")))
                  ]),
                  _c("el-checkbox", {
                    attrs: { disabled: _vm.destinationPortService.clearCheck },
                    model: {
                      value: _vm.destinationPortService.checkState,
                      callback: function($$v) {
                        _vm.$set(_vm.destinationPortService, "checkState", $$v)
                      },
                      expression: "destinationPortService.checkState"
                    }
                  }),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("SeaExport.ClearStatuses")))
                  ]),
                  _c("el-checkbox", {
                    on: {
                      change: function(val) {
                        if (val) {
                          _vm.destinationPortService.checkState = false
                        }
                      }
                    },
                    model: {
                      value: _vm.destinationPortService.clearCheck,
                      callback: function($$v) {
                        _vm.$set(_vm.destinationPortService, "clearCheck", $$v)
                      },
                      expression: "destinationPortService.clearCheck"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "USER_DEFINED_FIELD1"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        _vm.$t("CargoMsg.Cargo_PleaseFill") +
                        _vm.$t("SeaExport.UserDefinedField1")
                    },
                    model: {
                      value: _vm.userDefinedField1,
                      callback: function($$v) {
                        _vm.userDefinedField1 = $$v
                      },
                      expression: "userDefinedField1"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "USER_DEFINED_FIELD2"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        _vm.$t("CargoMsg.Cargo_PleaseFill") +
                        _vm.$t("SeaExport.UserDefinedField2")
                    },
                    model: {
                      value: _vm.userDefinedField2,
                      callback: function($$v) {
                        _vm.userDefinedField2 = $$v
                      },
                      expression: "userDefinedField2"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "USER_DEFINED_FIELD3"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        _vm.$t("CargoMsg.Cargo_PleaseFill") +
                        _vm.$t("SeaExport.UserDefinedField3")
                    },
                    model: {
                      value: _vm.userDefinedField3,
                      callback: function($$v) {
                        _vm.userDefinedField3 = $$v
                      },
                      expression: "userDefinedField3"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "USER_DEFINED_FIELD4"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        _vm.$t("CargoMsg.Cargo_PleaseFill") +
                        _vm.$t("SeaExport.UserDefinedField4")
                    },
                    model: {
                      value: _vm.userDefinedField4,
                      callback: function($$v) {
                        _vm.userDefinedField4 = $$v
                      },
                      expression: "userDefinedField4"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "WAREHOUSE_CMP"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("cargo-company-select", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          "method-params": { warehouse: true, active: true },
                          "default-value": _vm.warehouseCmp || "",
                          placeholder:
                            _vm.$t("CargoMsg.Cargo_PleaseFill") +
                            (_vm.isOpenWarehouse
                              ? _vm.$t("SeaExport.WarehouseSupplier")
                              : _vm.$t("CargoMsg.Cargo_Warehouse"))
                        },
                        on: {
                          change: function(p) {
                            _vm.warehouseCmp = p.value || 0
                            _vm.warehouseChangeHandler(p.value)
                          }
                        }
                      }),
                      _vm.isOpenWarehouse
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                "allow-create": true,
                                filterable: "",
                                clearable: true,
                                placeholder:
                                  _vm.$t("CargoMsg.Cargo_PleaseFill") +
                                  _vm.$t("SeaExport.WareHouseName")
                              },
                              model: {
                                value: _vm.warehouseName,
                                callback: function($$v) {
                                  _vm.warehouseName = $$v
                                },
                                expression: "warehouseName"
                              }
                            },
                            _vm._l(_vm.warehouseNameList, function(
                              item,
                              index
                            ) {
                              return _c("el-option", {
                                key: index,
                                attrs: {
                                  label: item.warehouseName,
                                  value: item.warehouseName
                                }
                              })
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "MBL_NO"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("mawb-no-input", {
                    ref: "mawbNoInput",
                    attrs: { editable: false },
                    model: {
                      value: _vm.mblNo,
                      callback: function($$v) {
                        _vm.mblNo = $$v
                      },
                      expression: "mblNo"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "CARRIER_ID"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "41",
                      filterable: "",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "method-params": {
                        airCmp: true,
                        companyLob: "airExport",
                        active: true
                      },
                      "default-value": _vm.carrierId || "",
                      headers: [
                        _vm.$t("Tool.ShortName"),
                        _vm.$t("Partners.chineseName")
                      ],
                      fields: ["shortName", "chineseName"],
                      placeholder:
                        _vm.$t("CargoMsg.Cargo_PleaseFill") +
                        _vm.$t("SeaExport.AirlineCompany")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.carrierId = p.value || 0
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "VOYAGE_FLIGHT"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder:
                        _vm.$t("CargoMsg.Cargo_PleaseFill") +
                        _vm.$t("SeaExport.Flight")
                    },
                    model: {
                      value: _vm.voyageFlight,
                      callback: function($$v) {
                        _vm.voyageFlight = $$v
                      },
                      expression: "voyageFlight"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "ESTIMATED_DELIVERY_TIME"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                      format: "yyyy-MM-dd HH:mm:ss",
                      placeholder:
                        _vm.$t("CargoMsg.Cargo_PleaseFill") +
                        _vm.$t("CargoMsg.Cargo_EstimatedDeliveryTime"),
                      clearable: ""
                    },
                    model: {
                      value: _vm.estimatedDeliveryTime,
                      callback: function($$v) {
                        _vm.estimatedDeliveryTime = $$v
                      },
                      expression: "estimatedDeliveryTime"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "ETD"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm",
                      format: "yyyy-MM-dd HH:mm",
                      placeholder:
                        _vm.$t("CargoMsg.Cargo_PleaseFill") +
                        _vm.$t("SeaExport.DateOfDeparture"),
                      clearable: ""
                    },
                    model: {
                      value: _vm.etd,
                      callback: function($$v) {
                        _vm.etd = $$v
                      },
                      expression: "etd"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "ETA"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "datetime",
                      "value-format": "yyyy-MM-dd HH:mm",
                      format: "yyyy-MM-dd HH:mm",
                      placeholder:
                        _vm.$t("CargoMsg.Cargo_PleaseFill") +
                        _vm.$t("SeaExport.DateOfArrival"),
                      clearable: ""
                    },
                    model: {
                      value: _vm.eta,
                      callback: function($$v) {
                        _vm.eta = $$v
                      },
                      expression: "eta"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "REMARKS"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 4,
                      placeholder:
                        _vm.$t("CargoMsg.Cargo_PleaseFill") +
                        _vm.$t("SeaExport.Remarks")
                    },
                    model: {
                      value: _vm.remarks,
                      callback: function($$v) {
                        _vm.remarks = $$v
                      },
                      expression: "remarks"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "BOOKING_AGENT"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "19",
                      filterable: "",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "method-params": { bookingAgent: true, active: true },
                      "default-value": _vm.bookingAgent || "",
                      placeholder: " "
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.bookingAgent = p.cmpIdx
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.dataCategoryValue === "DESTINATION_AGENT"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("cargo-advance-select", {
                        attrs: {
                          no: "destinationAgent",
                          "select-type": _vm.selectTypeNames.basic_data_Company,
                          "method-params": {
                            overseaAgent: true,
                            companyLob: "seaExport",
                            active: true
                          },
                          "default-value": _vm.destinationAgent || "",
                          disabled: _vm.clearByBusiness,
                          filterable: "",
                          headers: [_vm.$t("Partners.englishName")],
                          fields: ["englishName"],
                          "tag-name": "englishName"
                        },
                        on: {
                          parentCallBack: function(p) {
                            _vm.destinationAgent = p.cmpIdx
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("CargoMsg.Cargo_ClearData") + ":") +
                          " "
                      ),
                      _c("el-checkbox", {
                        on: {
                          change: function($event) {
                            return _vm.onClearByBusinessChange()
                          }
                        },
                        model: {
                          value: _vm.clearByBusiness,
                          callback: function($$v) {
                            _vm.clearByBusiness = $$v
                          },
                          expression: "clearByBusiness"
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "TRUCKING_CMP"
            ? _c(
                "el-form-item",
                { attrs: { label: _vm.$t("SeaExport.AfterAdjustment") } },
                [
                  _c(
                    "div",
                    { staticStyle: { display: "flex" } },
                    [
                      _c("cargo-company-select", {
                        attrs: {
                          no: "carryingCmp",
                          "method-params": { truckCmp: true, active: true },
                          "default-value": _vm.carryingCmp || "",
                          placeholder: _vm.$t("CargoMsg.Cargo_keyWordsTip")
                        },
                        on: {
                          change: function(p) {
                            _vm.carryingCmp = p.value || 0
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { margin: "0 auto", width: "fit-content" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _vm.dataCategoryValue === "EQ_SIZE_TYPE"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.isBusinessPeople
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.businessConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "CATEGORY_OF_GOODS_TYPE"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.categoryConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "ETA_DATE_TYPE"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateDateConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "CUR_ETA_DATE_TYPE"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateCurDateHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "ATD_ATA_DATE_TYPE"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateAtdAtaDateConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "ORIGINAL_ETA_DATE_TYPE"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateOriginalDateHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "CONTAINER_AND_SEAL_NO_TYPE"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.containerConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "USER_DEFINED_FIELD1"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.userDefinedFieldHandler(
                        "userDefinedField1",
                        _vm.userDefinedField1
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "USER_DEFINED_FIELD2"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.userDefinedFieldHandler(
                        "userDefinedField2",
                        _vm.userDefinedField2
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "USER_DEFINED_FIELD3"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.userDefinedFieldHandler(
                        "userDefinedField3",
                        _vm.userDefinedField3
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "USER_DEFINED_FIELD4"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.userDefinedFieldHandler(
                        "userDefinedField4",
                        _vm.userDefinedField4
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "WAREHOUSE_CMP"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateWarehouseDataConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "MBL_NO"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.userDefinedFieldHandler("mblNo", _vm.mblNo)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "CARRIER_ID"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateCarrierIdConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "VOYAGE_FLIGHT"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.userDefinedFieldHandler(
                        "voyageFlight",
                        _vm.voyageFlight
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "ESTIMATED_DELIVERY_TIME"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.userDefinedFieldHandler(
                        "estimatedDeliveryTime",
                        _vm.estimatedDeliveryTime
                      )
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "ETD"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.userDefinedFieldHandler("etd", _vm.etd)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "ETA"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.userDefinedFieldHandler("eta", _vm.eta)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "REMARKS"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.batchUpdateJobData }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.isLocalService
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.localServiceConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.isDestinationPortService
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.destinationPortServiceConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "BOOKING_AGENT"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.bookingAgentConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "DESTINATION_AGENT"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.destinationAgentConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "IC_CARRIER_COMPANY"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.icDataTypeConfirmHandler("CARRIER_COMPANY")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "IC_BOOKING_AGENT"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.icDataTypeConfirmHandler("BOOKING_AGENT")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "IC_WAREHOUSE_SUPPLIER"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.icDataTypeConfirmHandler("WAREHOUSE_SUPPLIER")
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _vm.dataCategoryValue === "TRUCKING_CMP"
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.carryingCmpConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      ),
      _vm.dataCategoryValue === "CUSTOMS" &&
      _vm.localService.checkState === true
        ? _c(
            "el-form",
            {
              attrs: {
                "label-width": _vm.$selectByLang("70px", "70px", "110px"),
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "custom",
                  attrs: { label: _vm.$t("SeaExport.CustomsBroker") + ":" }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      no: "customsBroker",
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "data-filter-function": _vm.customsBrokerFilter,
                      filterable: "",
                      "default-value": "",
                      "method-params": {
                        customsBroker: true,
                        companyLob: "seaExport",
                        active: true
                      }
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.customsBroker = p.value || 0
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.failDialog.visible,
            title: _vm.$t("Message.Prompt"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.failDialog, "visible", $event)
            }
          }
        },
        [
          _c("el-input", {
            attrs: { disabled: true, type: "textarea", rows: 10 },
            model: {
              value: _vm.failDialog.content,
              callback: function($$v) {
                _vm.$set(_vm.failDialog, "content", $$v)
              },
              expression: "failDialog.content"
            }
          }),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.copyFailJobNos }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.CopyFailedBusinessNumber")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.failDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Close")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.carryingCmpBlockDialog.visible,
            title: _vm.$t("Message.Prompt"),
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.carryingCmpBlockDialog, "visible", $event)
            }
          }
        },
        [
          _c("div", [
            _vm._v(_vm._s(_vm.$t("SeaExport.CarryingCmpAdjustBlockedTip")))
          ]),
          _c("div", { staticStyle: { margin: "8px 0 4px" } }, [
            _vm._v(_vm._s(_vm.$t("SeaExport.AbnormalBusinessNo")))
          ]),
          _c(
            "div",
            {
              staticStyle: {
                "max-height": "200px",
                "overflow-y": "auto",
                border: "1px solid #ebeef5",
                "border-radius": "4px",
                padding: "4px 8px"
              }
            },
            _vm._l(_vm.carryingCmpBlockDialog.jobNos, function(jobNo) {
              return _c("div", { key: jobNo }, [_vm._v(_vm._s(jobNo))])
            }),
            0
          ),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.carryingCmpBlockDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Close")))]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }